import apiClient from './apiClient';

// Create Profile
export const createProfile = async (formData) => {
  try {        
    
    const token = localStorage.getItem('token');
    const response = await apiClient.post('Profile/Create', formData, {
      headers: {
          Authorization: `Bearer ${token}`
      }
  });
  return response.data;
  } catch (error) {
    //console.error('Profile creation failed:', error);
    //throw error;
  }
};

export const verifyOtp = async (data) => {
    const res = await apiClient.post('Account/verify-otp', data);
    return res.data;
};

// Get Profile
export const getProfile = async (id) => {
  try {
    const token = localStorage.getItem('token');
    const response = await apiClient.get(`Profile/Get${id}`, {
      headers: {
          Authorization: `Bearer ${token}`
      }
  });
  return response.data;
  } catch (error) {
    //console.error('Fetching profile failed:', error);
    //throw error;
  }
};

// Update Profile
export const updateProfile = async (id, formData) => {
  try {
    const token = localStorage.getItem('token');
    const response = await apiClient.put(`Profile/update/${id}`, formData, {
      headers: {
          Authorization: `Bearer ${token}`
      }
  });
  return response.data;
  } catch (error) {
    //console.error('Profile update failed:', error);
    //throw error;
  }
};

export const createUserBanking = async (formData) => {
  try {
    const token = localStorage.getItem('token');
    const response = await apiClient.post('ProfilePayment/Create', formData, {
      headers: {
          Authorization: `Bearer ${token}`
      }
  });
  return response.data;
  } catch (error) {
    //console.error('Profile Banking creation failed:', error);
    //throw error;
  }
};

export const getUserBankig = async (id) => {
  try {

    const token = localStorage.getItem('token');
    const response = await apiClient.get(`ProfilePayment/Get${id}`, {
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        return response.data;
  } catch (error) {
    //console.error('Fetching profile banking failed:', error);
    //throw error;
  }
};

export const updateUserBanking = async (id, formData) => {
  try {
    const token = localStorage.getItem('token');
    const response = await apiClient.put(`ProfilePayment/update/${id}`, formData, {
      headers: {
          Authorization: `Bearer ${token}`
      }
  });
  return response.data;
  } catch (error) {
   // console.error('Profile update failed:', error);
    //throw error;
  }
};

export const GetAllUser = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await apiClient.get('Account/GetAll', {
      headers: {
          Authorization: `Bearer ${token}`
      }
  });
  return response.data;
  } catch (error) {
    //console.error('Fetching profile failed:', error);
    //throw error;
  }
};

export const GetAllRole = async () => {
  try {
    const token = localStorage.getItem('token');
    const response = await apiClient.get('Role/getall', {
      headers: {
          Authorization: `Bearer ${token}`
      }
  });
  return response.data;
  } catch (error) {
    //console.error('Fetching profile failed:', error);
    //throw error;
  }
};

export const createUser = async (formData) => {
  try {        
    
    const token = localStorage.getItem('token');
    const response = await apiClient.post('Account/register', formData, {
      headers: {
          Authorization: `Bearer ${token}`
      }
  });
  return response.data;
  } catch (error) {
    //console.error('Profile creation failed:', error);
    //throw error;
  }
};

export const createrole = async (formData) => {
  try {        
    
    const token = localStorage.getItem('token');
    const response = await apiClient.post('Role/create', formData, {
      headers: {
          Authorization: `Bearer ${token}`
      }
  });
  return response.data;
  } catch (error) {
    //console.error('Profile creation failed:', error);
    //throw error;
  }
};

export const updateUser = async (userId, formData) => {
  try {
      const token = localStorage.getItem('token');
      const response = await apiClient.put(`Account/update-password`, {
          userId: userId,       // Pass the userId
          newPassword: formData.newPassword,  // Pass the new password
      }, {
          headers: {
              Authorization: `Bearer ${token}`,
          }
      });
      return response.data;
  } catch (error) {
      console.error('Profile update failed:', error);
      throw error;
  }
};
